import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import { getFunctions, httpsCallable } from 'firebase/functions';
// import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { isMyAppWKWebView } from "./isMyAppWKWebView";

export async function callFirebaseFunction<
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  RequestData = any,
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  ResponseData = any
>(name: string, args: RequestData): Promise<ResponseData> {
  const startTime = performance.now();

  if (window.Android) {
    if (!window._androidPromise) {
      window._androidPromise = {};
    }

    const promiseId = window.crypto.randomUUID();
    const returnPromise = new Promise<string>((resolve, reject) => {
      // biome-ignore lint/style/noNonNullAssertion: <explanation>
      window._androidPromise![promiseId] = { resolve, reject };
    });

    window.Android.callFirebaseFunction(
      promiseId,
      name,
      args === undefined ? null : JSON.stringify(args)
    );

    return returnPromise
      .catch((e) => {
        Sentry.captureException(e, {
          extra: { function: name, args },
        });
        throw e;
      })
      .finally(() => {
        const endTime = performance.now();
        posthog.capture("callFirebaseFunction_return", {
          name,
          duration: endTime - startTime,
          platform: 'android'
        });
      })
      .then((s) => JSON.parse(s));
  }

    // const auth = getAuth();
    // console.log('did I make it here');
    // if (!auth.currentUser) {
    //   console.log('will try to log in');
    //   await signInWithEmailAndPassword(auth, 'test@example.com', 'password123');
    //   console.log(auth.currentUser);
    // } 

    // else {
    //   console.log(auth.currentUser);
    // }

  if (isMyAppWKWebView()) {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    const returnPromise = (window.webkit as any).messageHandlers.callFirebaseFunction.postMessage({
        name,
        args,
      }) as Promise<ResponseData>;

    return returnPromise
      .catch((e) => {
        Sentry.captureException(e, {
          extra: { function: name, args },
        });
        throw e;
      })
      .finally(() => {
        const endTime = performance.now();
        posthog.capture("callFirebaseFunction_return", {
          name,
          duration: endTime - startTime,
          platform: 'ios'
        });
      });
  }

  try {
    // const auth = getAuth();
    // if (!auth.currentUser) {
    //   await signInWithEmailAndPassword(auth, 'test@example.com', 'password123');
    // }

    const functions = getFunctions();
    const functionCall = httpsCallable(functions, name);
    
    const result = await functionCall(args);
    
    const endTime = performance.now();
    posthog.capture("callFirebaseFunction_return", {
      name,
      duration: endTime - startTime,
      platform: 'web'
    });

    return result.data as ResponseData;
  } catch (e) {
    Sentry.captureException(e, {
      extra: { function: name, args },
    });
    throw e;
  }

  // throw new Error("Unsupported platform");
}

